import EventBus from 'js-event-bus';

import { TokensI } from './contexts/Auth/authTokens';

const eventBus = new EventBus();

export type EventLogin = {
  action: 'login';
  tokens: TokensI;
};

export type EventLogout = {
  action: 'logout';
};

export type EventAntiFloodException = {
  action: 'anti_flood_exception';
  timeout: number;
};

export type EventUpdateData = {
  action: 'update_profile' | 'update_features' | 'update_services';
  force?: boolean;
};

export type EventModalForceClose = {
  action: 'modal_force_close';
};

export type EventUniversalLink = {
  action: 'universal_link';
  url: string;
};

export type EventSessionExpired = {
  action: 'session_expired';
  url: Nullable<string>;
};

type Events =
  | EventLogin
  | EventLogout
  | EventAntiFloodException
  | EventUpdateData
  | EventModalForceClose
  | EventUniversalLink
  | EventSessionExpired;

export const on = <Event extends Events>(event: Event['action'], cb: (e: Event) => Promise<void> | void): void => {
  eventBus.on(event, function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    cb(this);
  });
};
export const emit = ({ action, ...context }: Events): void => eventBus.emit(action, context);
export const die = <Event extends Events>(event: Event['action']): void => eventBus.die(event);
